import { type UseQueryResult, useQuery } from 'react-query';
import { type TableParamsType } from '../../types/common';
import { ParticipantBrokerAccountUpdatedHistoryService } from '../../services/wealthlane-customer-services/services/ParticipantBrokerAccountUpdatedHistoryService';
import { Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_ParticipantBrokerAccountHistoryDto } from '../../services/wealthlane-customer-services/models/Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_ParticipantBrokerAccountHistoryDto';

const useGetParticipantBrokerAccountHistory = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  // tableInfo: TableParamsType,
  participantBrokerAccountId: string
): UseQueryResult<
  | Array<Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_ParticipantBrokerAccountHistoryDto>
  | undefined,
  unknown
> => {
  // const { filter, sorting, skipCount, maxResultCount } = tableInfo;

  const switchSandboxList = useQuery(
    ['getParticipantBrokerAccountHistory', participantBrokerAccountId],
    async () => {
      return await handleRequest(
        ParticipantBrokerAccountUpdatedHistoryService.getApiCustomerApiAppParticipantBrokerAccountUpdatedHistoryBrokerAccountUpdatedHistoryByParticipantBrokerAccountId(
          participantBrokerAccountId
          // filter
          // sorting,
          // skipCount,
          // maxResultCount
        )
      );
    }
  );

  return switchSandboxList;
};

export default useGetParticipantBrokerAccountHistory;
